function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5.69,
  d: "M64 32H15.21"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 49.57V14.43L0 32l23 17.57z",
  fill: "currentColor"
});

function SvgArrowLeftLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDY0IDY0Ij4KICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjUuNjkiIGQ9Ik02NCAzMkgxNS4yMSIvPgogIDxwYXRoIGQ9Ik0yMyA0OS41N1YxNC40M0wwIDMybDIzIDE3LjU3eiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { SvgArrowLeftLine as ReactComponent };